import * as React from 'react';

import { Input } from '@/components/ui/input';
import { cn } from '@/shared/lib/cn';

function formatUzPhone(digits: string): string {
  // Format: 90-900-90-90 (2-3-2-2 guruh, chiziqcha bilan)
  const d = digits.slice(0, 9);
  const p1 = d.slice(0, 2);
  const p2 = d.slice(2, 5);
  const p3 = d.slice(5, 7);
  const p4 = d.slice(7, 9);
  return [p1, p2, p3, p4].filter((s) => s.length > 0).join('-');
}

/**
 * Har qanday telefon qiymatini (E164, raw, formatли) "+998 90-900-90-90"
 * ko'rinishiga keltiradi — saqlash/ko'rsatish uchun (PhoneInput onChange E164
 * qaytaradi, lekin ko'p forma formatli ko'rinishda saqlaydi/ko'rsatadi). '' agar bo'sh.
 */
export function toUzPhoneDisplay(value: string): string {
  const d = value.replace(/\D/g, '').replace(/^998/, '').slice(0, 9);
  if (d.length === 0) return '';
  return `+998 ${formatUzPhone(d)}`.trimEnd();
}

interface PhoneInputProps extends Omit<
  React.ComponentProps<'input'>,
  'value' | 'onChange' | 'type'
> {
  value: string;
  onChange: (e164: string) => void;
}

export function PhoneInput({
  value,
  onChange,
  className,
  ...rest
}: PhoneInputProps): React.ReactElement {
  const digits = value.replace(/\D/g, '').replace(/^998/, '').slice(0, 9);
  const display = formatUzPhone(digits);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const raw = e.target.value.replace(/\D/g, '').replace(/^998/, '').slice(0, 9);
    onChange(raw.length === 0 ? '' : `+998${raw}`);
  };

  return (
    <div
      className={cn('flex items-stretch rounded-md border border-input bg-background', className)}
    >
      <span className="flex items-center border-r border-input px-3 text-sm text-muted-foreground select-none">
        +998
      </span>
      <Input
        {...rest}
        type="tel"
        inputMode="numeric"
        value={display}
        onChange={handleChange}
        placeholder="90-900-90-90"
        className="border-0 shadow-none focus-visible:ring-0"
      />
    </div>
  );
}
